import Api from '@/providers/Api';
import { QUESTION_TYPES } from '@/store/index';

export const SET_CONDITION_VARIABLES_MUTATION =
  'SET_CONDITION_VARIABLES_MUTATION';
export const SET_CONDITION_VARIABLES_LOADING_MUTATION =
  'SET_CONDITION_VARIABLES_LOADING_MUTATION';
export const GET_CONDITION_VARIABLES_ACTION = 'GET_CONDITION_VARIABLES_ACTION';

export default {
  state: {
    items: [],
    loading: false,
  },
  getters: {
    variablesVisibilityConditionItems: ({ items }) =>
      items.filter(({ question }) => question.type !== QUESTION_TYPES.SLIDER),
    responseValueConditionVariables: ({ items }) =>
      items.filter(({ question }) => question.type === QUESTION_TYPES.SLIDER),
  },
  mutations: {
    [SET_CONDITION_VARIABLES_LOADING_MUTATION]: function (state, payload) {
      state.loading = payload;
    },
    [SET_CONDITION_VARIABLES_MUTATION]: function (state, payload) {
      state.items = payload;
    },
  },
  actions: {
    [GET_CONDITION_VARIABLES_ACTION]: async function ({ commit }) {
      commit(SET_CONDITION_VARIABLES_LOADING_MUTATION, true);
      try {
        const variables = await Api.getAllConditionVariables();
        commit(SET_CONDITION_VARIABLES_MUTATION, variables);
        return variables;
      } catch (e) {
        throw e;
      } finally {
        commit(SET_CONDITION_VARIABLES_LOADING_MUTATION, false);
      }
    },
  },
};
